/**
 * @param param0 Tuple of available options
 * @param cur Current value
 * @returns The opposite of the current value
 */
export const getOpposite = <T>([opt1, opt2]: [T, T], cur: T) => (cur === opt1 ? opt2 : opt1);
